import React, { useEffect, useState } from 'react'
import useApi from '../../hooks/useApi'
import { useDispatch, useSelector } from 'react-redux';
import { set_master_data } from '../../redux/slices/masterDataSlice';
import { BiLoaderAlt } from 'react-icons/bi';
import axios from 'axios';
import { customStringify } from '../../utils';
import { FormattedMessage, useIntl } from 'react-intl';
import { network_tl } from '../../translations';
import RetryApi from "../RetryApi";
import { ROLE_CHECKER } from '../../constants';

const MasterData = ({children}) => {
    const { Axios } = useApi();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const master_data = useSelector(state => state.master_data);
    const intl = useIntl();

    const getMasterData = async () => {
        try{
            setLoading(true)
            setError(false)
            const result = await Axios.get("api/main/master");
            const result_cat = await Axios.get("api/main/category?limit=10&offset=0")
            const result_sup = await Axios.get("api/main/supplier?limit=10&offset=0")
            const result_user = await Axios.get(`api/user/?limit=10&offset=0&role=${ROLE_CHECKER.value}`)
            const result_defect_area = await Axios.get(`api/main/defect-quality/area`)
            let all_defect_areas = []
            result_defect_area.data.payload.map(item => {
                all_defect_areas = [...all_defect_areas, ...item.defect_area_details]
            })
            // dispatch(set_master_data(result.data.payload))
            dispatch(set_master_data({
                suppliers: result_sup.data.payload,
                categories: result_cat.data.payload,
                users: result_user.data.payload,
                defect_area: result_defect_area.data.payload,
                // defect_area: result_defect_area.data.payload.map(item => {
                //     return {
                //         ...item,
                //         translations: item.translations.map(i => (
                //             {
                //                 ...i,
                //                 name: i.code === "en" ? "ABC" :i.name
                //             }
                //         ))
                //     }
                // }),
                all_defect_detail: all_defect_areas,
                ...result.data.payload,
            }))
            setLoading(false)
        } catch(e){
            if(axios.isCancel(e)){

            } else if(e.response){
                setError(customStringify(e.response.data.description))
                setLoading(false)
            } else{
                setError(network_tl(intl))
                setLoading(false)
            }
        }
    }

    useEffect(() => {
        if(!master_data){
            //master data hasn't been loaded, call API
            getMasterData()
        }
    }, [])

    return (
        loading && !error ?
        <div className="lg:pl-[230px] w-full fixed top-0 bottom-0 left-0 right-0 flex flex-col items-center justify-center">
            <p className="text-lg mb-5">
                <FormattedMessage id="loading_master" defaultMessage={"Loading Master Data..."} />
            </p>
            <BiLoaderAlt className="text-4xl animate-spin"/>
        </div>
        : !loading && error ?
            <RetryApi retry={getMasterData} error={error}/>
        : !loading && !error ?
        children
        :
        null
    )
}

export default MasterData